module.exports = __webpack_public_path__ + "img/mobile_app.c5923181.png";